import { render, staticRenderFns } from "./AutomationWizardPanelFooter.vue?vue&type=template&id=56d3748c&scoped=true&"
import script from "./AutomationWizardPanelFooter.vue?vue&type=script&lang=js&"
export * from "./AutomationWizardPanelFooter.vue?vue&type=script&lang=js&"
import style0 from "./AutomationWizardPanelFooter.vue?vue&type=style&index=0&id=56d3748c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d3748c",
  null
  
)

export default component.exports